import { useCallback, useContext } from "react";
import { ModalsWrapperContext, useForm } from "@kanda-libs/ks-component-ts";
import type { UseFormReturn } from "react-hook-form";
import { Flag, actions } from "@kanda-libs/ks-frontend-services";
import { useToast } from "@kanda-libs/ks-design-library";
import { useSelector } from "react-redux";
import companySelectors from "store/selectors/company";
import { useAppDispatch } from "components/shared/App";
import { MODAL_ID } from "./constants";

export type AddCompanyRiskStatusFormValues = Pick<Flag, "level" | "remark">;

export interface AddCompanyRiskStatusButtonHook {
  form: UseFormReturn<AddCompanyRiskStatusFormValues>;
  onSubmit: (values: AddCompanyRiskStatusFormValues) => void;
  onShowModal: () => void;
  isLoading: boolean;
}

export default function useAddCompanyRiskStatusButton(): AddCompanyRiskStatusButtonHook {
  const form = useForm<AddCompanyRiskStatusFormValues>();
  const dispatch = useAppDispatch();
  const { showError, showSuccess } = useToast();
  const company = useSelector(companySelectors.getEntity);
  const isLoading = useSelector(companySelectors.getIsSubmitting);
  const { showModal, hideModal } = useContext(ModalsWrapperContext);

  const onShowModal = () => {
    showModal(MODAL_ID);
  };

  const onSubmit = useCallback(
    (flag: AddCompanyRiskStatusFormValues) => {
      if (!company?.id) {
        showError("Company ID not found");
        return;
      }

      dispatch(
        actions.postMonitorFlag({
          body: flag,
          params: {
            id: company.id as string,
          },
          onSuccess: () => {
            showSuccess("Flag created successfully");
            hideModal(MODAL_ID);
          },
          onError: () => {
            showError("Error creating flag");
          },
        })
      );
    },
    [company?.id, showError, actions.postMonitorFlag, showSuccess, hideModal]
  );

  return {
    form,
    onSubmit,
    onShowModal,
    isLoading: isLoading,
  };
}
